import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';

@Component({
  selector: 'app-news-information-form',
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule, SelectFormFieldComponent],
  templateUrl: './news-information-form.component.html',
  styleUrl: './news-information-form.component.scss'
})
export class NewsInformationFormComponent {
  @Input() form!: FormGroup; 
  @Input() authors: any[] = [];  
  @Input() newsTypes: any[] = [];  

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
  }
}
